import { render, staticRenderFns } from "./LectureTrackSubjects.vue?vue&type=template&id=5be88f8e&scoped=true"
import script from "./LectureTrackSubjects.vue?vue&type=script&lang=js"
export * from "./LectureTrackSubjects.vue?vue&type=script&lang=js"
import style0 from "./LectureTrackSubjects.vue?vue&type=style&index=0&id=5be88f8e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be88f8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be88f8e')) {
      api.createRecord('5be88f8e', component.options)
    } else {
      api.reload('5be88f8e', component.options)
    }
    module.hot.accept("./LectureTrackSubjects.vue?vue&type=template&id=5be88f8e&scoped=true", function () {
      api.rerender('5be88f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LectureTrackSubjects.vue"
export default component.exports